import {TotalPriceSection_PriceBreakdown_CheckoutTotal} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/basket_sections.types';
import {useFormatCurrency} from '@aboutyou/i18n';
import {COLORS, FONT_SIZES, FONT_WEIGHTS, Text} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

interface CheckoutTotalProps {
  className?: string;
}

export const CheckoutTotal: React.FC<
  TotalPriceSection_PriceBreakdown_CheckoutTotal & CheckoutTotalProps
> = ({amount, label, secondaryPriceLabel, taxInformation, className}) => {
  const formatCurrency = useFormatCurrency();

  return (
    <Container className={className} data-testid="basketTotalPriceRow">
      <Label data-testid="basketTotalPriceLabel">
        {label}
        {taxInformation && <TaxText>{taxInformation}</TaxText>}
      </Label>
      <Label data-testid="basketTotalPrice">
        <Currency>
          {formatCurrency(amount.amount, amount.currencyCode)}
        </Currency>
        {secondaryPriceLabel && (
          <SecondaryPriceLabel
            data-testid="totalPriceSecondaryPriceLabel"
            color="Text.Grey"
          >
            {secondaryPriceLabel}
          </SecondaryPriceLabel>
        )}
      </Label>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 2px 8px;
`;

const Label = styled(Text)`
  display: flex;
  gap: 8px;
  align-items: baseline;
  flex-wrap: wrap;
  font-size: ${FONT_SIZES.px20}; // make sure if update to also update secondaryPriceLabel
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  line-height: ${FONT_SIZES.px24};
  color: inherit;
`;

const TaxText = styled(Text)`
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  line-height: ${FONT_SIZES.px18};
  color: ${COLORS.Grey1};
`;

const Currency = styled.span`
  white-space: nowrap;
`;

const SecondaryPriceLabel = styled(Text)`
  font-weight: ${FONT_WEIGHTS.mediumBold};
  font-size: ${FONT_SIZES.px20}; // needs to match the font size of the main price
`;
